import React, { Component } from 'react';
import SumaContexto from '../../../contexto/SumaContexto';
import { withRouter } from "react-router-dom";
import { Spin, Tooltip, Button, Table, Tag } from 'antd';
import { EyeOutlined, SearchOutlined } from '@ant-design/icons';
import ServicioUsuarios from '../../../servicios/usuarios/ServicioUsuarios'
import ServicioAdministracion from '../../../servicios/ServicioAdministracion'
import Constantes from '../../../utilidades/Constantes'
import Utilidades from '../../../utilidades/Utilidades'
import queryString from 'query-string';
import { withCookies } from 'react-cookie';
import FiltroColumna from '../../../general/tabla/FiltroColumna'
import FiltroEtiqueta from '../../../general/tabla/FiltroEtiqueta'

class ListarEstadosSolicitudDependencia extends Component {

    static contextType = SumaContexto;

    ENUM_COMPONENTE = {
        CARGANDO: 1,
        VER: 2,
        NO_DISPONIBLE: 3,
        NO_HABILITADO: 4
    }

    state = {
        cargando: true,
        componente: this.ENUM_COMPONENTE.CARGANDO,
        usuario: undefined,

        filtro: {},
        filtroEtiquetas: [],
    };


    constructor(props) {
        super(props);
        this.servicioUsuarios = new ServicioUsuarios(props);
        this.servicioAdministracion = new ServicioAdministracion(props);

        let contexto = this;
        this.filtroColumna = new FiltroColumna(props,( valores ) => {contexto.setSumaState(valores, contexto)});
    }


    // -----------------------------------------------------------------------
    // --- CARGA DATOS INICIALES ---------------------------------------------
    // -----------------------------------------------------------------------
    async cargarDatosIniciales() {

        let params = this.props.location.search;
        let urlparametros = queryString.parse(params);
        let idDependencia = undefined;

        if (urlparametros.id !== undefined && !isNaN(parseInt(urlparametros.id))) {
            idDependencia = parseInt(urlparametros.id);
        }
        this.setSumaState({ idDependencia });
        
        let usr = await this.servicioUsuarios.usuarioEnSesion();
        if (usr !== null) {

            let habilitado = Utilidades.accionPermitida(usr, Constantes.ENUMS_MODULOS.DEPENDENCIA.ACCIONES.LISTAR_ESTADOS_SOLICITUD_DEPENDENCIA.id);
            if (habilitado) {
                let estados = [{label: 'Activo', value: '1'},{label: 'Inactivo', value: '0'}];
                this.setSumaState({ usuario: usr, componente: this.ENUM_COMPONENTE.VER, cargando: true, estados:estados });
                await this.cargarDatosTabla(this);
            }else{
                this.setSumaState({ componente: this.ENUM_COMPONENTE.NO_HABILITADO });
            }
            this.setSumaState({ cargando: false });
        } else {
            this.setSumaState({ componente: this.ENUM_COMPONENTE.NO_DISPONIBLE });
        }

    }

    componentDidMount() {
        this._isMounted = true;
        this.cargarDatosIniciales();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    setSumaState(valores) {
        if (this._isMounted) {
            this.setState(valores);
        }
    }


    // 'limpiarFiltro': Método (clearFilters) que es propio de la tabla antDesign para limpiar los filtros
    // 'confirmarFiltro': Método (confirm) que es própio de la tabla antDesign para aplicar el filtro
    // 'dataIndex': Retorna el campo que se está filtrando
    // 'selectedKeys': Retorna el valor a filtrar;
    async cargarDatosTabla(contexto, limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) {
        let filtro = contexto.state.filtro;

        console.log('filtro',filtro);

        if (dataIndex !== undefined) { // Si el filtro es aplicado, se agrega la columna filtrada
            filtro[dataIndex] = selectedKeys;
        }        
        contexto.setSumaState({ cargando: true, filtro: filtro });

        // Se construye el filtroApi a partir de lo que fue filtrado en la tabla
        let filtroApi = {
            ...(filtro.id && filtro.id.length > 0 && {id:filtro.id[0]} ),
            ...(filtro.estadoSolicitudDependencia && filtro.estadoSolicitudDependencia.length > 0 && {estadoSolicitudDependencia:filtro.estadoSolicitudDependencia[0]} ),
            ...(filtro.descripcion && filtro.descripcion.length > 0 && {descripcion:filtro.descripcion[0]} ),
            ...(filtro.estadoSolicitud && filtro.estadoSolicitud.length > 0 && {estadoSolicitud:filtro.estadoSolicitud[0]} ),

            ...(filtro.activo && filtro.activo.length > 0 && filtro.activo[0].opc && {activo:filtro.activo[0].opc.join()} ),
        };

        console.log('filtroApi',filtroApi);
        
        await this.servicioAdministracion.obtenerEstadosSolicitudDependencia( this.state.idDependencia, filtroApi )
            .then(( vistaEstSolDep ) => {
                contexto.setSumaState({ vistaEstSolDep, cargando: false });
                console.log('vistaEstSolDep',vistaEstSolDep);
            }).then(() => {
                if (limpiarFiltro !== undefined) { limpiarFiltro(); }
                if (confirmarFiltro !== undefined) { confirmarFiltro(); }
            });
    }


    render() {
        const { componente, usuario, vistaEstSolDep, estados } = this.state;
        let { filtro } = this.state;
        filtro = filtro || {};
        let contexto = this;

        const columns = [
            {
                title: 'Id',
                dataIndex: 'id',
                key: 'id',
                with:100,
                sorter: (a, b) => a.id - b.id,
                filteredValue: filtro.id || null,
                ...this.filtroColumna.busquedaTexto(
                    'Identificador',
                    'id',
                    (limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) => { contexto.cargarDatosTabla(contexto, limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) }
                ),
            },
            {
                title: 'Estado dependencia',
                dataIndex: 'estadoSolicitudDependencia',
                key: 'estadoSolicitudDependencia',
                sorter: (a, b) => a.estadoSolicitudDependencia ? a.estadoSolicitudDependencia.localeCompare(b.estadoSolicitudDependencia) : 1,
                filteredValue: filtro.estadoSolicitudDependencia || null,
                ...this.filtroColumna.busquedaTexto(
                    'Estado dependencia',
                    'estadoSolicitudDependencia',
                    (limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) => { contexto.cargarDatosTabla(contexto, limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) }
                ),
            },
            {
                title: 'Descripción',
                dataIndex: 'descripcion',
                key: 'descripcion',
                sorter: (a, b) => a.descripcion ? a.descripcion.localeCompare(b.descripcion) : 1,
                filteredValue: filtro.descripcion || null,
                ...this.filtroColumna.busquedaTexto(
                    'Descripción',
                    'descripcion',
                    (limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) => { contexto.cargarDatosTabla(contexto, limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) }
                ),
                responsive: ['sm'], /* visible en pantalla con ancho ≥ 576px*/
            },
            {
                title: 'Estado SUMA+',
                dataIndex: 'estadoSolicitud',
                key: 'estadoSolicitud',
                sorter: (a, b) => a.estadoSolicitud ? a.estadoSolicitud.localeCompare(b.estadoSolicitud) : 1,
                filteredValue: filtro.estadoSolicitud || null,
                ...this.filtroColumna.busquedaTexto(
                    'Estado SUMA+',
                    'estadoSolicitud',
                    (limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) => { contexto.cargarDatosTabla(contexto, limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) }
                ),
            },
            {
                title: 'Estado',
                key: 'activo',
                align: 'center',
                dataIndex: 'activo',
                sorter: (a, b) => (a.activo === b.activo)? 0 : a.activo? -1 : 1,
                filteredValue: filtro.activo || null,
                ...this.filtroColumna.busquedaOpciones(
                    'Estado',
                    'activo',
                    (limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) => { contexto.cargarDatosTabla(contexto, limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) },
                    estados
                ),
                render: (text, record) => (
                    <>
                        <Tag key={text} color={(record.activo) ? 'green' : 'volcano' }>
                            {record.activo ? 'Activo' : 'Inactivo'}
                        </Tag>
                    </>
                ),
                responsive: ['sm'], /* visible en pantalla con ancho ≥ 576px*/
            },
            {
                title: 'Opciones',
                key: 'opciones',
                align: 'center',
                className: 'columna-opciones',
                width: 112,
                render: (text, record) => (
                    <>
                        <Tooltip title="Ver opción">
                            <Button shape="circle" disabled={!Utilidades.accionPermitida(usuario, Constantes.ENUMS_MODULOS.DEPENDENCIA.ACCIONES.VER_ROL.id)}
                                icon={<EyeOutlined style={{ 'color': '#c90a00' }} />}
                                onClick={(e) => { this.props.callbackAdministrarRol( undefined, record.id) }} />
                        </Tooltip>
                    </>
                ),
            },
        ];

        return (
            <div>
                {(componente === this.ENUM_COMPONENTE.VER) ?
                    (
                        <>
                            <Spin tip="Por favor espera..." size="large" spinning={this.state.cargando}>

                                <h3 className="sub-titulo-separador">Estados de la solicitud de la dependencia</h3>
                                <div className="seccion-datos seccion-final">

                                    {
                                        this.state.filtroEtiquetas.length > 0 ?
                                            (<div className="seccion-filtros-etiquetas">
                                                <div className="titulo-filtro-etiquetas">
                                                    <label>Filtros <SearchOutlined /> :</label>
                                                </div>

                                                {
                                                    this.state.filtroEtiquetas.map((filtroEtiqueta, i) => {
                                                        return (
                                                            <FiltroEtiqueta key={i}
                                                                dataIndex={filtroEtiqueta.dataIndex}
                                                                texto={filtroEtiqueta.texto}
                                                                onClose={filtroEtiqueta.borrarFiltro} />
                                                        )
                                                    })
                                                }
                                            </div>)
                                            :
                                            (<></>)
                                    }

                                    <Table  columns={columns}
                                            dataSource={ vistaEstSolDep ? vistaEstSolDep : []  }
                                            rowKey={"id"} />
                                </div>

                            </Spin>

                        </>
                    )
                    :
                    (
                        (componente === this.ENUM_COMPONENTE.CARGANDO) ?
                            (<Spin tip="Por favor espera..." className="solo-spin-cargando" size="large" />)
                            : (
                                (componente === this.ENUM_COMPONENTE.NO_HABILITADO ?
                                    <label>Listar estados solicitud dependencia no disponible. {Constantes.MENSAJE_USUARIO_SIN_PERMISOS}</label> :
                                (componente === this.ENUM_COMPONENTE.NO_DISPONIBLE) ? (<label>Contenido no disponible. [Cod:LSTESTSOLDEP]</label>) : (<></>))
                            )
                    )
                }
            </div>
        );
    }
}

export default withRouter(withCookies(ListarEstadosSolicitudDependencia));